import React from "react";

export default function MailIcon({ fill, size, className, onClickCallback }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      className={className}
    >
      <defs>
        <path
          id="a1ayycpxaa"
          d="M2 2h16c1.105 0 2 .895 2 2v12c0 1.105-.895 2-2 2H2c-1.11 0-2-.9-2-2V4c0-1.11.89-2 2-2zm8 7l8-5H2l8 5zm-8 7h16V6.37l-8 4.99-8-4.99V16z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g transform="translate(-78 -737) translate(32 555) translate(32 168) translate(14 14)">
                    <path d="M0 0H20V20H0z" />
                    <mask id="29v1ccksdb" fill="#fff">
                      <use xlinkHref="#a1ayycpxaa" />
                    </mask>
                    <use
                      fill="#000"
                      fillRule="nonzero"
                      xlinkHref="#a1ayycpxaa"
                    />
                    <path
                      fill={fill}
                      d="M0 0H20V20H0z"
                      mask="url(#29v1ccksdb)"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
